<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered is-size-3">
                <span>
                    Operaciones actuales del usuario seleccinado
                </span>
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section style="background:#F8F9FD;" class="modal-card-body">
            <div style="background:#F8F9FD;" role="navigation" aria-label="main navigation" class="">
                <div class="">
                    <a class="mr-3 mb-3 button is-rounded" :class="{
                'has-background-info-dark': selectedUser && selectedUser.user_id == user.user_id,
                'has-background-info-light': selectedUser == null || selectedUser.user_id != user.user_id,
                'has-text-white': selectedUser && selectedUser.user_id == user.user_id,
                'has-text-black': selectedUser == null || selectedUser.user_id != user.user_id
            }" @click="() => selectUser(user)" v-for="user in allUsers" v-bind:key="user.user_id">
                        {{ user.user_email }}
                    </a>
                </div>
            </div>
            <div class="columns">
                <div class="column is-12">
                    <InputWithValidation id="urlLooker" name="urlLooker" label="Url Looker:" v-model="urlLooker"
                        rules="required" />
                </div>
            </div>
            <div class="columns">
                <div class="column is-2">
                    <label class="checkbox">
                        <input type="checkbox" v-model="hasConciliator" />
                        Tiene conciliador
                    </label>
                </div>
                <div class="column is-2">
                    <label class="checkbox">
                        <input type="checkbox" v-model="hasReport" />
                        Tiene reporte embebido
                    </label>
                </div>
                <div class="column is-3">
                    <label class="checkbox">
                        <input type="checkbox" v-model="noHasSIIMsg" />
                        No mostrar mensaje de conectar el SII
                    </label>
                </div>
                <div class="column is-3">
                    <label class="checkbox">
                        <input type="checkbox" v-model="isActive" />
                        Puede ingresar a la plataforma
                    </label>
                </div>
                <div class="column is-2">
                    <label class="checkbox">
                        <input type="checkbox" v-model="canUploadFiles" />
                        Puede subir archivos
                    </label>
                </div>
            </div>
            <div class="container" v-if="selectedUser">
                <strong>Archivos que este usuario puede subir:</strong>
                <table class="table is-narrow">
                    <tbody>
                        <tr v-for="index in (allFiles.length - 1)" :key="index">
                            <td v-if="index % 2 == 0">
                                <label class="checkbox">
                                    <input type="checkbox" :checked="allFiles[index].active"
                                        @change="selectFiles($event, allFiles[index])" />
                                    {{ allFiles[index].desc }}
                                </label>
                            </td>
                            <td v-if="index % 2 == 0 && index + 1 < allFiles.length">
                                <label class="checkbox">
                                    <input type="checkbox" :checked="allFiles[index + 1].active"
                                        @change="selectFiles($event, allFiles[index + 1])" />
                                    {{ allFiles[index + 1].desc }}
                                </label>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
            <button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
            <button class="button is-primary" :disabled="loading || selectedUser == null" role="button"
                @click="updateUserOperations()">
                Grabar
            </button>
        </footer>
    </div>
</template>

<script>
import { updateUserOperations } from "@/api/carteraAnalista";
import InputWithValidation from "@/components/inputs/InputWithValidation";
export default {
    name: "ChangeOperationsByUsers",
    data() {
        return {
            loading: false,
            fileByUser: [],
            selectedUser: null,
            urlLooker: "",
            hasConciliator: false,
            hasReport: false,
            noHasSIIMsg: false,
            isActive: false,
            canUploadFiles: false,
            allFiles: [],
        };
    },
    components: {
        InputWithValidation
    },
    methods: {
        selectFiles(event, file) {
            file.active = event.target.checked
        },
        selectUser(user) {
            this.selectedUser = user
            this.urlLooker = user.url_report
            this.hasConciliator = user.has_conciliator
            this.hasReport = user.has_embedded_report
            this.noHasSIIMsg = user.no_sii_message
            this.isActive = user.is_active
            this.canUploadFiles = user.has_file_upload

            this.allFiles = this.selectedUser.all_files.map(file => {
                let newFile = { ...file }
                newFile.active = this.selectedUser.files_id.includes(newFile.id)
                return newFile
            })
        },
        updateUserOperations() {
            const reqUserOps = {
                user_id: this.selectedUser.user_id,
                url_report: this.urlLooker,
                has_conciliator: this.hasConciliator,
                has_embedded_report: this.hasReport,
                no_sii_message: this.noHasSIIMsg,
                is_active: this.isActive,
                has_file_upload: this.canUploadFiles,
                updated_files: this.allFiles,
            }
            updateUserOperations(this.idCompany, reqUserOps).then(() => {
            }).finally(() => {
                this.$emit("close");
            })
        }
    },
    props: ["idCompany", "allUsers"],
    created() {
    },
};
</script>